import {EquipmentUsage} from './usage.model';
import {Asset} from './asset.model';
import {NOT_AVAILABLE} from './usage.const';
import {
  ASSET_PACKAGE_STATUS_IN_PRICING,
  ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING,
  ASSET_PACKAGE_STATUS_SENT_FOR_PRICING
} from '../asset-package';

export class AssetInfoValidationResult {
  isValid: boolean;
  errorMsg: string;
}
export class AssetInfo {
  assetId: number;
  categoryId: number;
  typeId: number;
  customDescrTxt: string;
  translatedDescr: string;
  serialNumber: string;
  licensePlate: string;
  usageQuantity: number = 0;
  usageTypeId: number = NOT_AVAILABLE;
  condition: string;
  sellerTrackingCode: string;
  sellerContractNumber: string;
  internalNotes: string;
  contractNotes: string;
  featuresText: string;
  displaySave: boolean;
  descriptionEditable: boolean;
  year: string;
  saveAttempted: boolean;
  modelId: number;
  modelName: string;
  manufacturerId: number;
  manufacturerName: string;
  unusedYn: boolean;
  inoperableYn: boolean;
  partsOnlyYn: boolean;
  glideredYn: boolean;
  usage: string;
  displayInAssetSummary: boolean;
  editAssetInformation:boolean = false;
  typeName: string;
  categoryName: string;
  conditionName: string;
  tiresUndercarriageRating: string;
  descriptionWithSerialNumber: string;
  canSaveAssetInfo: boolean;
  equipId: number;
  vinLocation: string;
  serialNumberPhotoUrls: string[];
  meterReadingPhotoUrls: string[];
  serialNumberPhotoUrl: string;
  meterReadingPhotoUrl: string;
  color: string;
  keyNumber: string;
  assetStatusId: number;
  duplicateSerialNumber: boolean;
  duplicateSellerTrackingCode: boolean;
  numberOfTitles: number;
  appraisalPostModelDescription: string;
  postModelDescription: string;
  isAssetTypeMisc: boolean;
  equipmentUsage: EquipmentUsage;
  comesWith: string;
  appraisalDescription: string;
  appraisalFeatures: string;
  vso: boolean;
  sequenced: boolean = false;
  assetPackageStatusId: number;
  mergeCheckList: boolean;

  public static getAssetInfoFromAsset(asset: Asset): AssetInfo {
    const assetInfo = new AssetInfo();
    assetInfo.assetId = asset.assetId;
    assetInfo.categoryId = asset.categoryId;
    assetInfo.typeId = asset.typeId;
    assetInfo.customDescrTxt = asset.customDescrTxt;
    assetInfo.translatedDescr = asset.translatedDescr;
    assetInfo.serialNumber = asset.serialNumber;
    assetInfo.licensePlate = asset.licensePlate;
    assetInfo.usageQuantity = asset.usageQuantity;
    assetInfo.usageTypeId = asset.usageTypeId;
    assetInfo.condition = asset.condition;
    assetInfo.sellerTrackingCode = asset.sellerTrackingCode;
    assetInfo.sellerContractNumber = asset.sellerContractNumber;
    assetInfo.internalNotes = asset.internalNotes;
    assetInfo.contractNotes = asset.contractNotes;
    assetInfo.year = asset.year;
    assetInfo.modelId = asset.modelId;
    assetInfo.modelName = asset.modelName;
    assetInfo.manufacturerId = asset.manufacturerId;
    assetInfo.manufacturerName = asset.manufacturerName;
    assetInfo.unusedYn = asset.unusedYn;
    assetInfo.inoperableYn = asset.inoperableYn;
    assetInfo.partsOnlyYn = asset.partsOnlyYn;
    assetInfo.glideredYn = asset.glideredYn;
    assetInfo.keyNumber = asset.keyNumber;
    assetInfo.categoryName = asset.categoryName;
    assetInfo.typeName = asset.typeName;
    assetInfo.isAssetTypeMisc = assetInfo.typeName && assetInfo.typeName.startsWith(':');
    assetInfo.conditionName = asset.conditionName;
    assetInfo.usage = asset.usage;
    assetInfo.tiresUndercarriageRating = asset.tiresUndercarriageRating;
    assetInfo.descriptionWithSerialNumber = assetInfo.customDescrTxt  ;
    if ( assetInfo.serialNumber) {
      assetInfo.descriptionWithSerialNumber += ' - ' + assetInfo.serialNumber;
    }
    assetInfo.equipId = asset.equipId;
    assetInfo.vinLocation = asset.vinLocation;
    assetInfo.serialNumberPhotoUrls = asset.serialNumberPhotoUrls;
    assetInfo.meterReadingPhotoUrls = asset.meterReadingPhotoUrls;
    assetInfo.color = asset.color;
    assetInfo.assetStatusId = asset.assetStatusId;
    assetInfo.featuresText = asset.featuresText;
    assetInfo.duplicateSerialNumber = asset.duplicateSerialNumber;
    assetInfo.duplicateSellerTrackingCode = asset.duplicateSellerTrackingCode;
    assetInfo.numberOfTitles = asset.numberOfTitles;
    assetInfo.postModelDescription = asset.postModelDescription;
    assetInfo.buildEquipmentUsage();
    assetInfo.comesWith = asset.comesWith;
    assetInfo.appraisalDescription = asset.appraisalDescription;
    assetInfo.appraisalFeatures = asset.appraisalFeatures;
    assetInfo.vso = asset.vso;
    assetInfo.assetPackageStatusId = asset.assetPackageStatusId;
    assetInfo.sequenced = asset.sequenced;
    assetInfo.mergeCheckList = asset.mergeCheckList;
    return assetInfo;
  }

  public setAssetFromAssetInfo(asset: Asset): Asset {
    asset.manufacturerId = this.manufacturerId;
    asset.manufacturerName = this.manufacturerName;
    asset.modelId = this.modelId;
    asset.modelName = this.modelName;
    asset.categoryId = this.categoryId;
    asset.categoryName = this.categoryName;
    asset.typeId = this.typeId;
    asset.typeName = this.typeName;
    asset.customDescrTxt = this.customDescrTxt;
    asset.translatedDescr = this.translatedDescr;
    asset.keyNumber = this.keyNumber;
    asset.serialNumber = this.serialNumber;
    asset.licensePlate = this.licensePlate;
    asset.usageQuantity = this.usageQuantity;
    asset.usageTypeId = this.usageTypeId;
    asset.condition = this.condition;
    asset.sellerTrackingCode = this.sellerTrackingCode;
    asset.sellerContractNumber = this.sellerContractNumber;
    asset.internalNotes = this.internalNotes;
    asset.contractNotes = this.contractNotes;
    asset.year = this.year;
    asset.unusedYn = this.unusedYn;
    asset.inoperableYn = this.inoperableYn;
    asset.partsOnlyYn = this.partsOnlyYn;
    asset.glideredYn = this.glideredYn;
    asset.tiresUndercarriageRating = this.tiresUndercarriageRating;
    asset.equipId = this.equipId;
    asset.vinLocation = this.vinLocation;
    asset.color = this.color;
    asset.numberOfTitles = this.numberOfTitles;
    asset.postModelDescription = this.postModelDescription;
    asset.descriptionEditable = this.descriptionEditable;
    asset.comesWith = this.comesWith;
    asset.appraisalDescription = this.appraisalDescription;
    asset.appraisalFeatures = this.appraisalFeatures;
    asset.vso = this.vso;
    asset.assetPackageStatusId = this.assetPackageStatusId;
    asset.mergeCheckList = this.mergeCheckList;
    this.buildEquipmentUsage();
    return asset;
  }

  public isValid(): boolean {
    let valid = true;
    if ( !this.typeId ) {
      valid = false;
    } else if ( this.isAssetTypeMisc ) {
      valid = false;
      if ( this.postModelDescription ) {
        if ( this.postModelDescription.length > 0 ) {
          valid = true;
        }
      }
    }
    return valid;
  }

  public buildEquipmentUsage() {
    this.equipmentUsage = new EquipmentUsage();
    this.equipmentUsage.usageQuantity = this.usageQuantity;
    this.equipmentUsage.usageTypeId = this.usageTypeId;
  }

  updateEquipmentUsage(equipmentUsage: EquipmentUsage): void {
    this.usageQuantity = equipmentUsage.usageQuantity;
    this.usageTypeId = equipmentUsage.usageTypeId;
  }

  public getDescriptionWithSerialNumber(): string {
    let descriptionWithSerialNumber = this.customDescrTxt;
    if (this.serialNumber) {
      descriptionWithSerialNumber += ' - ' + this.serialNumber;
    }
    return descriptionWithSerialNumber;
  }

  public isAssetOnly(): boolean {
    return this.assetId !== null && this.assetId !== undefined && this.assetId > 0
      && (this.equipId === null || this.equipId === undefined || this.equipId === 0);
  }

  public isEquipWithAsset(): boolean {
    return this.assetId !== null && this.assetId !== undefined && this.assetId > 0
        && this.equipId !== null && this.equipId !== undefined && this.equipId > 0;
  }

  public isEquipWithoutAsset(): boolean {
    return (this.assetId === null || this.assetId === undefined || this.assetId === 0)
      && this.equipId !== null && this.equipId !== undefined && this.equipId > 0;
  }

  public isEquip(): boolean {
    return this.equipId !== null && this.equipId !== undefined && this.equipId > 0;
  }

  public isAssetPackageInPricing(): boolean {
    return this.assetId !== null && (this.assetPackageStatusId === ASSET_PACKAGE_STATUS_SENT_FOR_PRICING || this.assetPackageStatusId === ASSET_PACKAGE_STATUS_IN_PRICING || this.assetPackageStatusId === ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING);
  }

  public validate(): AssetInfoValidationResult {
    const validationResult: AssetInfoValidationResult = new AssetInfoValidationResult();
    validationResult.isValid = false;
    if ( !this.typeId ) {
      validationResult.errorMsg = 'Asset Type is required';
    } else if ( !this.categoryId ){
      validationResult.errorMsg = 'Asset Category is required';
    } else if ( this.typeId && !this.customDescrTxt ){
      validationResult.errorMsg = 'Description is Required ';
    } else if (this.customDescrTxt && this.customDescrTxt.length > 400) {
      validationResult.errorMsg = 'Description field is too large, try with a short Post Model Description value';
    } else if ( this.isAssetTypeMisc && !this.postModelDescription ){
      validationResult.errorMsg = 'Post Model Description is required';
    } else {
      validationResult.isValid = true;
    }
    return validationResult;
  }
}
